import React, { useEffect } from "react";
import Header from "../Component/Header";
import Footer from "../Component/Footer";
import { Link } from "react-router-dom";
function Infrastructure() {
  useEffect(() => {
    document.title = "Infrastructure -  CARMEL CONVENT SCHOOL, DHARUHERA";
  }, []);
  return (
    <>
      <Header />
      <div className="sliderbg"></div>
      <div className="innerpage">
        <div className="container">
          <div className="row">
            <div className="col-12">
              <ul className="breadcrumbli">
                <li>
                  <Link to="/"> Home </Link>
                </li>
                <li>Academics</li>
                <li>Facility</li>
              </ul>
            </div>
            <div className="col-lg-12">
              <h2 className="innerheading">Facility</h2>
            </div>
          </div>
          <div className="row g-4 Club-gallery">
            <div class="col-lg-12"><p>Carmel Convent has a spacious, well planned building with well-ventilated classrooms surrounded by lawns and playgrounds. </p><p>The Computer labs equipped with the latest computers and multimedia technology. </p><p>The Audio-Visual Room is equipped both for teaching the students and viewing the presentations made by them. The use of audio visual aids is well integrated with the school curriculum and this room is extensively used by the staff and students alike. </p><p>The school has a School Library. The reference library which is fully computerized and houses over 2,000 books, is a treasure trove of information that continues to grow each year. Reading sessions are conducted regularly exposing students to good written and reading skills. </p><p>Carmel has playgrounds, dance room, music room for the children. During the activity period these grounds and rooms are used for various activities like skating, taekwondo, dance, exercising etc. </p></div>
          </div>
          <div className="facility-section mb-4">
            <h5>1. Library</h5>
            <p>
              <strong>"A Reader Today, A Leader Tomorrow."</strong>
            </p>
            <p>
              The Library at Carmel Convent School, Dharuhera is a peaceful and inspiring learning space that nurtures curiosity, creativity, and a lifelong love for reading. It serves as a gateway to knowledge, encouraging students to explore new ideas, broaden their perspectives, and develop independent learning habits.<br />
              Our well-equipped library houses more than 2,500 carefully selected books, including storybooks, reference books, encyclopedias, biographies, magazines, and subject-specific resources. The collection caters to the interests and academic needs of students across all grades.<br />
              Regular reading sessions, storytelling activities,  help cultivate effective reading, writing, and communication skills. The library also promotes critical thinking, imagination, and research abilities, empowering students to become confident and responsible learners.
              <br />
              At Carmel Convent School, we believe that every book opens the door to new possibilities, and our library is a place where young minds discover the joy of learning, the power of knowledge, and the habit of lifelong reading.
            </p>
          </div>
          <div className="facility-section mb-4">
            <h5>2. Computer Lab</h5>
            <p>
              Our well-equipped Computer Lab provides students with a modern and interactive learning environment to develop essential digital skills. Equipped with more than 60 computers, multimedia projectors, LED panels, high-speed internet connectivity, and the latest educational software, the lab offers hands-on learning in computer applications, coding, and information technology. Under the guidance of qualified teachers, students enhance their creativity, logical thinking, problem-solving skills, and responsible use of technology, preparing them to excel in the ever-evolving digital world.
            </p>
            <div className="row g-4 Club-gallery">
              <div className="col-xl-3 col-lg-4 col-md-6 col-sm-6 col-12">
                <div className="Club-card">
                  <img src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/CCSDH/public/Images/ComputerLab-1.jpeg" alt="carmelconventschooldharuhera" />
                </div>
              </div>
              <div className="col-xl-3 col-lg-4 col-md-6 col-sm-6 col-12">
                <div className="Club-card">
                  <img src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/CCSDH/public/Images/ComputerLab-2.jpeg" alt="carmelconventschooldharuhera" />
                </div>
              </div>
              <div className="col-xl-3 col-lg-4 col-md-6 col-sm-6 col-12">
                <div className="Club-card">
                  <img src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/CCSDH/public/Images/ComputerLab-3.jpeg" alt="carmelconventschooldharuhera" />
                </div>
              </div>
              <div className="col-xl-3 col-lg-4 col-md-6 col-sm-6 col-12">
                <div className="Club-card">
                  <img src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/CCSDH/public/Images/ComputerLab-4.jpeg" alt="carmelconventschooldharuhera" />
                </div>
              </div>
            </div>
          </div>


          <div className="facility-section mb-4">
            <h5>3. Medical Room</h5>
            <p>
              The Medical Room at Carmel Convent School is designed to ensure the health, safety, and well-being of every student. It is equipped with first-aid facilities, comfortable sick beds, a wheelchair, and essential medical supplies to provide immediate care in case of minor illnesses or injuries. The school also has ramp accessibility and a lift, ensuring quick and safe movement of students in case of illness or emergency. Our commitment is to provide a safe, caring, and supportive environment where every child's well-being is a priority.
            </p>

            <div className="row g-4 Club-gallery">
              <div className="col-xl-3 col-lg-4 col-md-6 col-sm-6 col-12">
                <div className="Club-card">
                  <img src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/CCSDH/public/Images/Medical-1.jpeg" alt="carmelconventschooldharuhera" />
                </div>
              </div>
              <div className="col-xl-3 col-lg-4 col-md-6 col-sm-6 col-12">
                <div className="Club-card">
                  <img src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/CCSDH/public/Images/Medical-2.jpeg" alt="carmelconventschooldharuhera" />
                </div>
              </div>

            </div>
          </div>
          <div className="facility-section mb-4">
            <h5>4. Digital Classrooms</h5>
            <p>
              At Carmel Convent School, all classrooms are equipped with smart digital technology, including interactive LED panels, to create an engaging and effective learning environment. These technology-enabled classrooms make lessons more interactive and easier to understand through multimedia presentations, educational videos, animations, and digital learning resources. By integrating technology into everyday teaching, we enhance students' conceptual understanding, encourage active participation, and prepare them with the digital skills needed for the future.
            </p>

            <div className="row g-4 Club-gallery">
              <div className="col-xl-3 col-lg-4 col-md-6 col-sm-6 col-12">
                <div className="Club-card">
                  <img src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/CCSDH/public/Images/DigitalClassrooms-1.jpeg" alt="carmelconventschooldharuhera" />
                </div>
              </div>
              <div className="col-xl-3 col-lg-4 col-md-6 col-sm-6 col-12">
                <div className="Club-card">
                  <img src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/CCSDH/public/Images/DigitalClassrooms-2.jpeg" alt="carmelconventschooldharuhera" />
                </div>
              </div>
              <div className="col-xl-3 col-lg-4 col-md-6 col-sm-6 col-12">
                <div className="Club-card">
                  <img src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/CCSDH/public/Images/DigitalClassrooms-3.jpeg" alt="carmelconventschooldharuhera" />
                </div>
              </div>
              <div className="col-xl-3 col-lg-4 col-md-6 col-sm-6 col-12">
                <div className="Club-card">
                  <img src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/CCSDH/public/Images/DigitalClassrooms-4.jpeg" alt="carmelconventschooldharuhera" />
                </div>
              </div>
            </div>
          </div>
          <div className="facility-section mb-4">
            <h5>5. Dance & Music Room</h5>
            <p>
              The Dance and Music Room at Carmel Convent School provides a vibrant and creative space where students discover and nurture their artistic talents. Equipped with the necessary musical instruments, audio-visual facilities, and a spacious practice area, the room encourages students to express themselves through music and dance. Regular training, performances, and cultural activities help develop confidence, creativity, teamwork, and an appreciation for India's rich cultural heritage.
            </p>
            <div className="row g-4 Club-gallery">
              <div className="col-xl-3 col-lg-4 col-md-6 col-sm-6 col-12">
                <div className="Club-card">
                  <img src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/CCSDH/public/Images/Dance-1.jpeg" alt="carmelconventschooldharuhera" />
                </div>
              </div>
            </div>
          </div>
          <div className="facility-section mb-4">
            <h5>6. CCTV Surveillance Campus</h5>
            <p>
              The safety and security of our students and staff are our highest priorities. The entire campus is monitored through a comprehensive CCTV surveillance system with more than 104 high-definition (HD) cameras strategically installed across classrooms, corridors, playgrounds, entrances, and other key areas. The surveillance system operates 24 hours a day, ensuring continuous monitoring and providing a safe, secure, and disciplined environment for learning and growth.
            </p>
          </div>
          <div className="facility-section mb-4">
            <h5>7. Composite Science Lab</h5>
            <p>
              Our Composite Science Lab is well equipped with a wide range of scientific models, laboratory apparatus, and experimental equipment for Physics, Chemistry, and Biology. It provides students with hands-on learning experiences through practical experiments, helping them develop scientific thinking, curiosity, and a deeper understanding of concepts.
            </p>
          </div>
          <div className="facility-section mb-4">
            <h5>8. Transport Facility</h5>
            <p>
              The school provides a safe and reliable transport facility through authorized contract-based bus services. Student safety and punctuality are our highest priorities. All buses are equipped with the latest safety features, including speed governors, first-aid kits, fire extinguishers, and are operated by experienced drivers with trained support staff.
            </p>
            <div className="row g-4 Club-gallery">
              <div className="col-xl-3 col-lg-4 col-md-6 col-sm-6 col-12">
                <div className="Club-card">
                  <img src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/CCSDH/public/Images/Transport-1.jpeg" alt="carmelconventschooldharuhera" />
                </div>
              </div>
            </div>
          </div>
          <div className="facility-section mb-4">
            <h5>9. Safe Drinking Water (RO System)</h5>
            <p>
              The school is committed to providing clean, safe, and hygienic drinking water to every student and staff member. Our campus is equipped with high-capacity RO (Reverse Osmosis) water purification systems and  water coolers, ensuring a continuous supply of pure, safe, and cool drinking water throughout the day.<br />
              The RO systems and water coolers are regularly cleaned, serviced, and maintained to uphold the highest standards of hygiene and quality. Safe drinking water keeps students healthy, hydrated, active, and focused, enabling them to learn and perform at their best in a safe and nurturing environment.
            </p>
            <div className="row g-4 Club-gallery">
              <div className="col-xl-3 col-lg-4 col-md-6 col-sm-6 col-12">
                <div className="Club-card">
                  <img src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/CCSDH/public/Images/RO-1.jpeg" alt="carmelconventschooldharuhera" />
                </div>
              </div>
            </div>
          </div>
          <div className="facility-section mb-4">
            <h5>10. Sports Area</h5>
            <p>
              The school provides a spacious and well-maintained Sports Area that promotes physical fitness, teamwork, and a healthy lifestyle. Students enjoy a basketball court, a large playground, and a dedicated children's play zone equipped with swings, slides, and trampolines for young learners. Regular sports activities and outdoor games help develop discipline, coordination, leadership, and sportsmanship while ensuring that every child enjoys active and joyful learning.
            </p>
            {/* <div className="row g-4 Club-gallery">
              <div className="col-xl-3 col-lg-4 col-md-6 col-sm-6 col-12">
                <div className="Club-card">
                  <img src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/CCSDH/public/Images/Sports-1.jpeg" alt="carmelconventschooldharuhera" />
                </div>
              </div>
            
            </div> */}


          </div>
          <div className="facility-section mb-4">
            <h5>11. Lift</h5>
            <p>
              The school is equipped with a modern lift facility to ensure convenience, accessibility, and safety. The lift is primarily used for medical emergencies, young children when required, and the movement of staff and visitors. Students are not permitted to use the lift alone or in groups without the supervision of a staff member.

            </p>

            <div className="row g-4 Club-gallery">
              <div className="col-xl-3 col-lg-4 col-md-6 col-sm-6 col-12">
                <div className="Club-card">
                  <img src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/CCSDH/public/Images/Lift-1.jpeg" alt="carmelconventschooldharuhera" />
                </div>
              </div>

            </div>

          </div>
          <div className="facility-section mb-4">
            <h5>12. Fire Safety</h5>
            <p>
              <strong>"Safety is Everyone's Responsibility."</strong>
            </p>
            <p>

              The school is committed to providing a safe and secure environment for all. The campus is equipped with fire extinguishers, fire alarms, emergency exits, and other essential fire safety equipment in accordance with safety standards. <br />
              To promote safety awareness and emergency preparedness, the school conducts fire safety demonstrations and mock drills from time to time. These sessions help students and staff understand emergency procedures and respond calmly, confidently, and effectively in case of a fire or any other emergency.
            </p>

            <div className="row g-4 Club-gallery">
              <div className="col-xl-3 col-lg-4 col-md-6 col-sm-6 col-12">
                <div className="Club-card">
                  <img src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/CCSDH/public/Images/Fire-1.jpeg" alt="carmelconventschooldharuhera" />
                </div>
              </div>

            </div>


          </div>
          <div className="facility-section mb-4">
            <h5>13. Taekwondo Training Room</h5>
            <p>
              <strong>"Discipline, Confidence, Strength."</strong>
            </p>
            <p>
              The school has a dedicated Taekwondo Training Room equipped with high-quality training mats to ensure safe and effective practice. Training is conducted under the guidance of a qualified Sports Teacher holding a Black Belt 2nd Dan, helping students develop self-discipline, confidence, physical fitness, self-defense skills, and sportsmanship in a safe and encouraging environment.
            </p>
            <div className="row g-4 Club-gallery">
              <div className="col-xl-3 col-lg-4 col-md-6 col-sm-6 col-12">
                <div className="Club-card">
                  <img src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/CCSDH/public/Images/Taekwondo-1.jpeg" alt="carmelconventschooldharuhera" />
                </div>
              </div>
              <div className="col-xl-3 col-lg-4 col-md-6 col-sm-6 col-12">
                <div className="Club-card">
                  <img src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/CCSDH/public/Images/Taekwondo-2.jpeg" alt="carmelconventschooldharuhera" />
                </div>
              </div>
            </div>
          </div>
          <div className="facility-section">
            <h5>14. Power Backup</h5>
            <p>
              To ensure uninterrupted learning and the smooth functioning of the school, the campus is equipped with a powerful generator for power backup. In the event of a power outage, the generator provides an immediate electricity supply, ensuring that classrooms, digital learning facilities, laboratories, offices, and other essential services continue to operate without disruption.

            </p>
            <div className="row g-4 Club-gallery">
              <div className="col-xl-3 col-lg-4 col-md-6 col-sm-6 col-12">
                <div className="Club-card">
                  <img src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/CCSDH/public/Images/Power-1.jpeg" alt="carmelconventschooldharuhera" />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div >
      <Footer />
    </>
  );
}

export default Infrastructure;
